import {
  ColumnFiltersState,
  getPaginationRowModel,
  getCoreRowModel,
  useReactTable,
  getSortedRowModel,
  ColumnDef,
  SortingState,
  VisibilityState,
  TableOptions,
  getFilteredRowModel,
} from '@tanstack/react-table';
import { useState } from 'react';

interface UseDataTableProps<TData, TValue> {
  columns: ColumnDef<TData, TValue>[];
  data: TData[];
  options: Pick<
    TableOptions<TData>,
    'initialState' | 'enableRowSelection' | 'globalFilterFn' | 'meta'
  >;
}

export function useDataTable<TData, TValue>({
  columns,
  data,
  options,
}: UseDataTableProps<TData, TValue>) {
  const [sorting, setSorting] = useState<SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>(
    options.initialState?.columnFilters ?? [],
  );
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({});
  const [rowSelection, setRowSelection] = useState({});
  const [globalFilter, setGlobalFilter] = useState(
    options.initialState?.globalFilter ?? '',
  );

  return useReactTable({
    data,
    columns,
    ...options,
    // built-in features
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onRowSelectionChange: setRowSelection,
    onColumnFiltersChange: setColumnFilters,
    onColumnVisibilityChange: setColumnVisibility,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    state: {
      columnFilters,
      columnVisibility,
      rowSelection,
      sorting,
      globalFilter,
    },
  });
}
